<template>
  <div class="nototalList_container">
    <Row>
      <Col :xs="{span:22,offset:1}" style="margin-top:30px;">
        <table style="width:100%" cellspacing="0" cellpadding="0" class="firstTable">
          <tr>
            <td colspan="4" style="font-size:14px;font-weight:700">总体情况</td>
          </tr>
          <tr>
            <td>公司名称</td>
            <td>{{table.company}}</td>
            <td>业务编号</td>
            <td>{{table.businessNo}}</td>
          </tr>
          <tr>
            <td>创建时间</td>
            <td>{{table.createdAt | formatWithhour}}</td>
            <td>保理金额</td>
            <td>{{table.money |moneyFilter}}</td>
          </tr>
          <tr>
            <td>期限</td>
            <td>{{table.limitTime}}</td>
            <td>手续费</td>
            <td>{{table.manageFee |moneyFilter}}</td>
          </tr>
          <tr>
            <td>利息</td>
            <td>{{table.interest|moneyFilter}}</td>
            <td>展期利息</td>
            <td>{{table.delayInterest|moneyFilter}}</td>
          </tr>
          <tr>
            <td>罚息</td>
            <td>{{table.fee |moneyFilter}}</td>
            <td>保理方</td>
            <td>{{table.realName}}</td>
          </tr>
          <tr>
            <td>产品名称</td>
            <td>{{table.productName}}</td>
            <td>类型</td>
            <td>{{table.productTypeName}}</td>
          </tr>
          <tr>
            <td>业务状态</td>
            <td colspan="3">{{table.state}}</td>
          </tr>
        </table>
      </Col>
      <Col :xs="{span:22,offset:1}" style="margin-top:50px;">
    <table
      style="width: 100%;font-size: 14px;font-weight: 700;border-collapse: collapse;border: 1px solid #D8D8D8;border-bottom: 0;">
      <tr style="background: #F1F1F1">
        <td colspan="7" style="padding: 10px 0 10px 20px">还款详情</td>
      </tr>
    </table>
    <Table border :columns="columns" :data="dBusinessRepayDetailDtos"></Table>
  </Col>
    </Row>
    <Row>
      <Col :xs="{span:22,offset:1}">
        <div style="display: flex;justify-content: center;margin-top:50px ">
          <my-button @confirm="goBack">返回</my-button>
        </div>
      </Col>
    </Row>
    <Modal
      v-model="modal2" @keyup.enter.native="submit">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span>支付密码</span>
      </p>
      <template>
        <password-input v-model="cashPassword" @input="password"></password-input>
      </template>
      <div slot="footer" style="display: flex;justify-content: center">
        <my-button @confirm="submit" >确定</my-button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  import MyButton from '@/components/MyButton'
  import passwordInput from '@/components/passwordInput'
  export default {
    name:'nototalList',
    components: {
      MyButton,
      passwordInput,
    },
    data() {
      return {
        urlBase: process.env.API_URL_BASE + '/commons/attachments/download.do?filename=',
        table:{
          state:'',
          businessId:''
        },
        applyLoan:{
          businessBiddingId: 0,
          cashPassword: "",
          investMoney: 0
        },
        dBusinessRepayDetailDtos:[{
          corpus:'',
          fee:'',
          interest:'',
          repayTime:'',
          period:'',
          repayDay:'',
          state:''
        }],
        modal2: false,
        modal1:false,
        cashPassword:'',
        businessRepayDetailId:'',
        columns:[
          {
            align:'center',
            title:'还款期数',
            key:'period',
            minWidth:100,
            render:(h,params) =>{
              if (params.row.period){
                return h('div', {
                },`${params.row.period}期`)
              } else {
                return
              }
            }
          },
          {
            align:'center',
            title:'本金',
            key:'corpus',
            minWidth:90,
            render: (h, params) => {
              if (params.row.corpus){
                return h('div', {
                },`￥${Number(params.row.corpus).toFixed(2)}`)
              } else {
                return h('div', {}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'管理费',
            key:'manageFee',
            minWidth:90,
            render: (h, params) => {
              if (params.row.manageFee){
                return h('div', {
                },`￥${Number(params.row.manageFee).toFixed(2)}`)
              } else {
                return h('div', {}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'利息',
            key:'interest',
            minWidth:90,
            render: (h, params) => {
              if (params.row.interest){
                return h('div', {
                }, `￥${Number(params.row.interest).toFixed(2)}`)
              } else {
                return h('div',{}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'罚息',
            key:'fee',
            minWidth:90,
            render: (h, params) => {
              if (params.row.fee){
                return h('div', {
                }, `￥${Number(params.row.fee).toFixed(2)}`)
              } else {
                return h('div',{}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'展期利息',
            key:'delayInterest',
            minWidth:90,
            render: (h, params) => {
              if (params.row.delayInterest){
                return h('div', {
                }, `￥${params.row.delayInterest.toFixed(2)}`)
              } else {
                return h('div',{}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'展期天数',
            key:'delayDays',
            minWidth:100,
            render:(h,params) =>{
              if (params.row.delayDays){
                return h('div', {
                },`${params.row.delayDays}天`)
              } else {
                return
              }
            }
          },
          {
            align:'center',
            title:'展期日期',
            key:'applyDelayedAt',
            minWidth:100,
            render:(h,params)=>{
              if(params.row.applyDelayedAt){
                return h('div', {}, this.$moment(params.row.applyDelayedAt).format('YYYY-MM-DD'))
              }else{
                return
              }
            }
          },
          {
            align:'center',
            title:'总还款金额',
            key:'totalMoney',
            minWidth:120,
            render: (h, params) => {
              if (params.row.totalMoney){
                return h('div', {
                }, `￥${Number(params.row.totalMoney).toFixed(2)}`)
              } else {
                return h('div',{}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'已还金额',
            key:'paidMoney',
            minWidth:120,
            render: (h, params) => {
              if (params.row.paidMoney){
                return h('div', {
                }, `￥${Number(params.row.paidMoney).toFixed(2)}`)
              } else {
                return h('div',{}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'未还金额',
            key:'unPaidMoney',
            minWidth:120,
            render: (h, params) => {
              if (params.row.unPaidMoney){
                return h('div', {
                }, `￥${Number(params.row.unPaidMoney).toFixed(2)}`)
              } else {
                return h('div',{}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'应还款时间',
            key:'repayDay',
            minWidth:120,
            render:(h,params)=>{
              if(params.row.repayDay){
                return h('div', {}, this.$moment(params.row.repayDay).format('YYYY-MM-DD'))
              }else{
                return
              }
            }
          },
          {
            align:'center',
            title:'实际还款时间',
            key:'repayTime',
            minWidth:140,
            render:(h,params)=> {
              if (params.row.repayTime) {
                return h('div', {}, this.$moment(params.row.repayTime).format('YYYY-MM-DD HH:mm'))
              } else {
                return
              }
            }
          },
          {
            align:'center',
            title:'操作',
            key:'action',
            minWidth:190,
            render:(h,params)=>{
              if(params.row.state == "还款中" || params.row.state =="逾期"){
                return h('div',[
                  h('Button',{
                    props:{
                      type:'error',
                      size:'small',
                    },
                    on:{
                      click:()=>{
                        this.businessRepayDetailId=params.row.businessRepayDetailId;
                        this.$Modal.confirm({
                          title: '提示',
                          content: "<span style='color: #000;font-size: 20px;'>请将还款金额汇至以下账户:"
                            + "<br>"+"<span>账户名称:中朗商业保理有限公司</span>"
                            + "<br>"+"<span>开户行:中国建设银行股份有限公司(上海虹口支行)</span>"
                            + "<br>"+"<span style='font-size:20px;'>公司账号:3105 0172 3600 0000 2566</span>"+
                            "<p style='color: #000;font-size: 20px;'>汇款成功后，请联系:18939822263 王先生</p>",
                        })
                      }
                    }
                  },'还款'),
                  h('Button',{
                    props:{
                      type:'success',
                      size:'small',
                    },
                    on:{
                      click:()=>{
                        this.$Modal.confirm({
                          title: '提示',
                          content: "您是否确定申请该期还款展期？",
                          onOk:()=>{
                            ApiClient.put(`/desktop/businessLoan/${params.row.businessRepayDetailId}/delayContract.do`).then(data=>{
                              this.$router.go(-1)
                            })
                        },
                        })
                      }
                    }
                  },'申请展期')
                ])
              }else if(params.row.state == "展期"){
                return h('div',[
                  h('Button',{
                    props:{
                      size:'small'
                    },
                    style:{
                      background:'#0080FF',
                      color:'#ffffff',
                      border:'0'
                    }
                  },'展期'),
                  h('Button',{
                    props:{
                      type:'error',
                      size:'small'
                    },
                    on:{
                      click:()=>{
                        this.businessRepayDetailId=params.row.businessRepayDetailId;
                        this.$Modal.confirm({
                          title: '提示',
                          content: "<span style='color: #000;font-size: 20px;'>请将还款金额汇至以下账户:"
                            + "<br>"+"<span>账户名称:中朗商业保理有限公司</span>"
                            + "<br>"+"<span>开户行:中国建设银行股份有限公司(上海虹口支行)</span>"
                            + "<br>"+"<span style='font-size:20px;'>公司账号:3105 0172 3600 0000 2566</span>"+
                            "<p style='color: #000;font-size: 20px;'>汇款成功后，请联系:18939822263王先生</span>",
                        })
                      }
                    }
                  },'还款')
                ])
              } else{
                return h('div',[
                  h('Button',{
                    props:{
                      type:'success',
                      size:'small'
                    },
                  },'已完成')
                ])
              }
            }
          }
        ],
      }
    },
    mounted() {
      this.initData();
    },
    methods: {
      goBack() {
        this.$router.push({
          name: 'myFinancing'
        })
      },
      account() {
        this.modal2 = true;
      },
      password(value) {
        this.cashPassword = value;
      },
      submit() {
        if (this.cashPassword.length === 6) {
          this.modal2 = false;
          let id = this.businessRepayDetailId;
          ApiClient.put(`/desktop/businessLoan/${this.$route.query.id}/repay.do`, {
            businessRepayDetailId: id,
            cashPassword: this.cashPassword,
          }, {silent: true}).then(data => {
            this.cashPassword = '';
            this.initData();
          }).catch(data => {
            this.cashPassword = '';
            if (data._response.data.code === 9054) {
              this.modal1 = true;
            }else{
              this.$Message.error(data.message)
            }
          })
        }
      },
      initData(){
        ApiClient.get(`/desktop/businessLoan/${this.$route.query.id}/detail.do`,).then(data => {
          this.table=data.dBusinessDetailDto;
          this.dBusinessRepayDetailDtos=data.dBusinessRepayDetailDtos;
        })
      },
    }
  }
</script>
<style lang="less" scoped>

  .popups {
    .have_img {
      padding-top: 0;
      padding-bottom: 0
    }

    img {
      width: 80px;
      height: auto;
      display: inline-block;
      vertical-align: middle;
    }
    table {
      margin: 20px auto;
      width: 90%;
      font-size: 12px;
      border-collapse: collapse;

      tr:nth-child(2n+1) {
        background: #F8F8F8;
      }
      tr:nth-child(1) {
        background: #ECF3FB;
        font-weight: bold;
        font-size: 14px;
      }
      tr {
        td {
          height: 42px;
          padding-left: 20px;
          border: 1px solid #bbcade;
        }
        td:nth-child(2n) {
          width: 33%;
        }
        td:nth-child(2n+1) {
          width: 20%;
        }
      }
    }
  }
</style>
<style lang="less">
  .popups {
    .ivu-modal-header {
      border: 0;
    }
    .ivu-modal-footer {
      border-top: 0;
    }
    .ivu-modal-header {
      background: #f1f1f1;
    }
  }

  .popups {
    .ivu-modal-footer {
      border-top: 0;
    }
  }

  .nototalList_container {
    .firstTable {
      border-collapse: collapse;
    }
    .firstTable tr:nth-child(odd) {
      background: #f1f1f1;
    }
    .firstTable td {
      border: 1px solid #ccc;
      padding: 10px 18px;
      color: #525252;
      font-size: 12px;
    }
    .secondTable table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    .secondTable table th {
      background: transparent;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/financingManagement/nototalList.vue